<template>
  <div class="about-pmgc">
    <navbar/>
    <div class="animated bounceInDown"><img src="../assets/code is next oil block.jpeg" alt="" class="responsive-img" width="100%"></div>
    <div class="header-text text-center center-align">
      <h4 class="center-align white-text animated slideInLeft">PMGC Coding Bootcamp </h4>
    </div>

    <div class="about-content row">
      <div class="card-image">
        <h3 class="header center-align">
          Platinum Minds Global Company
        </h3>
      </div>
      <div class="col s12 m8 offset-m2">
        <div class="card-panel grey-text text-darken-3">
          <span>
            <p class="animated fadeIn">
                Let your child take over from Elon Muks Jeff Bezous, Mark Zuckerberg & Bill Gates...</p>

            <p>
                These are the techi great guys across the world...
            </p>
            <p>
                 Some of these billionaires will always refer  to how their parents enrolled them in a coding school as a childhood anytime they are talking about the foundation....
It's more than obvious that Technology is taking over almost all aspects of humanity ;And the fundamental knowledge of tech-driven innovation is programming.
            </p>
            <p>
                With programming, you solve basic and complex human problems.
Soon enough  (and which is already happening), tech will replace thousands of job. Hence, it's a skill for the present and the future.
            </p>
                Have you heard of PMGC Programming Bootcamp?
<br/>
<br/>
It's your chance of enrolling your child/children for learning Programming & Maths and related technologies during this holiday to prepare your children ahead of the future that lies ahead, register for PMGC Programming bootcamp coming up July 27th - August 27th 2022 at Lugbe Abuja. Both online and offline packages are available.
<br/>
<p>
    Click <a href="https://docs.google.com/forms/d/e/1FAIpQLScmbj-6VeT9rBkGTsU-n_4zpM2bB64G-rdcrb5SuCOHKXlTKw/viewform" target="_blank">here</a> to get started

</p>
<br/>

For more information, contact 08160342073, 08102690790, 08102590791.
          </span>
        </div>
      </div>
    </div>
    <!-- Our mission -->
    <!-- <div class="ourMission-content row">
      <div class="card-image">
        <h3 class="header center-align">
          Our Mission
        </h3>
      </div>
      <div class="col s12 m8 offset-m2">
        <div class="card-panel grey-text text-darken-3" style="padding: 0.5rem 1.5rem;">
          <div>
            <div class="arrow-right"></div><p class="animated fadeIn">
              To identify talented intellectuals, employing their deft hands into gigantic innovations for the development of the World.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            Providing a free avenue for educational consultancy.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            To achieve a contest where graduates can be camped in our upcoming empire; providing them materials with different task to perform, i.e., production of gadget that can solve the problem of manpower in industries, providing solutions to present and future health problems, addressing problem peculiar to economy crisis of any country, solving the problems of fading agriculture in Nigeria and other countries, etc.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            Solving of problems peculiar to supply and distribution of general goods.
          </p>
          </div>
        </div>
      </div>
    </div> -->

    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
export default {
  components: {Navbar, FooterPage}
}
</script>

<style>
  div.about-pmgc h4.center-align.white-text.animated.slideInLeft {
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    padding: 1rem;
    top: 50% !important;
    left: 0px;
    right: 0px;
    font-weight: bold;
    text-transform: uppercase;
  }
  img.responsive-img, video.responsive-video {
    max-width: 100%;
    height: auto;
    opacity: .4;
}
  div.about-pmgc .card-panel.grey-text.text-darken-3 {
    padding: 0.5rem 2.4rem !important;
  }

  div.about-pmgc .arrow-right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #263238;
    position: absolute;
    left: 18.5%;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/bootcamp.vue